import { createContext, useContext, useEffect, useState } from 'react';
import { api } from './utils/api';
import Clarity from '@microsoft/clarity';

const UserContext = createContext({
  currentUser: null,
  setCurrentUser: () => {},
  refreshUser: async () => {},
  loading: false,
});

export function useCurrentUser() {
  return useContext(UserContext);
}

export function UserProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    setLoading(true);
    const token = localStorage.getItem('refresh_token');

    if (!token) {
      setCurrentUser(null);
      setLoading(false);
      return;
    }

    try {
      const { data } = await api.get('/users/me');
      setCurrentUser(data);
    } catch (err) {
      console.error('Failed to fetch user:', err);
      setCurrentUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshUser();
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    if (currentUser?.id) {
      Clarity.identify(String(currentUser.id));
    } else {
      Clarity.identify(null);
    }
  }, [currentUser]);

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser, refreshUser, loading }}>
      {children}
    </UserContext.Provider>
  );
}
